export default __webpack_public_path__ + "static/media/appointments.95f121e5.jpg";